import { ToastContainer } from 'react-toastify';
import { useRouter } from 'next/router';
import ApiConnectionProblem from '@components/elements/ApiConnectionProblem';
import Loading from '@components/elements/Loading/Loading';
import ErrorBoundary from '@components/elements/ErrorBoundary';
import MissingDataModal from '@components/elements/MissingDataModal/MissingDataModal.js';
import DefaultLayout from '@components/layouts/DefaultLayout';
import ROUTE_URLS from '@constants/routeUrls';
import BasketMethodsProvider from '@contexts/BasketMethods.context';
import useOrderForm from '@hooks/useOrderForm';

import AppListener from './AppListener';

const AppOrCrash = ({ Component, pageProps }) => {
  const Layout = Component.Layout || DefaultLayout;
  const router = useRouter();
  const isNewOrderRoute = router.asPath?.startsWith(ROUTE_URLS.NEW_ORDER_FORM);
  const { isLoading: isOrderFormLoading, isSuccess: isOrderFormSuccess } =
    useOrderForm({ enabled: isNewOrderRoute });

  if (pageProps.configError) {
    return <ApiConnectionProblem />;
  }

  if (isNewOrderRoute && (isOrderFormLoading || !isOrderFormSuccess)) {
    return <Loading isLoading={true} showLoadingText={false} />;
  }

  return (
    <>
      <AppListener {...pageProps} />
      <BasketMethodsProvider {...pageProps}>
        <Layout>
          <MissingDataModal />
          <ErrorBoundary>
            <Component {...pageProps} />
          </ErrorBoundary>
          <ToastContainer enableMultiContainer={true} />
        </Layout>
      </BasketMethodsProvider>
    </>
  );
};

export default AppOrCrash;
